import React from "react";
import Styles from './styles.module.scss';
import { useTranslation } from "react-i18next";

const ApplyFormS1 = () => {
    const { t } = useTranslation();

    return (
        <section className={Styles.container}>
            <div className={Styles.absLine}/>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.contentWrapTitle}`}>{t('Форма заявки на IDO')}</div>
                <div className={`${Styles.noteWrap}`}>
                    <div className={`${Styles.noteItem}`}><span>{t('Важно')}: </span>{t('Обратите внимание на мошенников, которые могут выдавать себя за нас в Telegram, LinkedIn, Twitter и по email. Проверяйте, что вся email-коммуникация приходит только с домена support@honeestarter.com. Злоумышленники могут использовать очень похожие адреса с минимальными отличиями. Всегда сначала подтверждайте подлинность любой коммуникации с нами.')}</div>
                </div>
            </div>
        </section>
    );
};

export default ApplyFormS1;




